import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Form, InputNumber, Space, Spin, Tooltip, message } from 'antd';
import { QuestionCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import diskAdminService from '../../services/diskAdminService';
import { toastErr } from './common';

/** 云盘设置：到期保留天数 / 免费额度 / 邮件附件分享有效期 / 已删除邮箱保留天数（disk_settings，GET/PUT /api/admin/disk/settings） */
const FIELDS = [
    { key: 'retention_days', label: '到期后保留天数', addon: '天', tip: '空间超出套餐（到期/降级）后，文件保留这么多天再清空', precision: 0 },
    { key: 'free_storage_gb', label: '免费空间', addon: 'GB', precision: 3 },
    { key: 'free_traffic_gb', label: '免费直链流量', addon: 'GB/月', precision: 3 },
    { key: 'mail_share_days', label: '邮件附件分享有效天数', addon: '天', tip: '链接到期后附件自动移入回收站（用户移走/加星/另行分享则保留）', precision: 0 },
    { key: 'deleted_mailbox_days', label: '已删除邮箱文件保留天数', addon: '天', tip: '删除邮箱后其文件在所有者「已删除邮箱」里保留这么多天，再移入回收站', precision: 0 },
];

const label = (f) => (f.tip
    ? <Space size={4}>{f.label}<Tooltip title={f.tip}><QuestionCircleOutlined style={{ color: '#999' }} /></Tooltip></Space>
    : f.label);

export default function DiskSettings() {
    const [form] = Form.useForm();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const r = await diskAdminService.getSettings();
            setData(r?.data || null);
            form.setFieldsValue(r?.data?.values || {});
        } catch (e) {
            toastErr(e, '加载失败');
        } finally {
            setLoading(false);
        }
    }, [form]);
    useEffect(() => { load(); }, [load]);

    const save = async (values) => {
        setSaving(true);
        try {
            const r = await diskAdminService.saveSettings(values);
            setData(r?.data || null);
            form.setFieldsValue(r?.data?.values || {});
            message.success('已保存');
        } catch (e) {
            toastErr(e, '保存失败');
        } finally {
            setSaving(false);
        }
    };

    const schema = data?.schema || {};
    return (
        <Card title="云盘设置" extra={<Button icon={<ReloadOutlined />} onClick={load} loading={loading} />}>
            <Spin spinning={loading && !data}>
                <Form form={form} layout="vertical" onFinish={save} style={{ maxWidth: 420 }}>
                    {FIELDS.map((f) => (
                        <Form.Item key={f.key} name={f.key} label={label(f)}
                            extra={data?.defaults ? `默认 ${data.defaults[f.key]}` : null}
                            rules={[{ required: true, message: '必填' }]}>
                            <InputNumber style={{ width: '100%' }} addonAfter={f.addon} precision={f.precision}
                                min={schema[f.key]?.min} max={schema[f.key]?.max} />
                        </Form.Item>
                    ))}
                    <Button type="primary" htmlType="submit" loading={saving}>保存</Button>
                </Form>
            </Spin>
        </Card>
    );
}
